import React, { useEffect, useState } from "react";
import axios from "axios";

import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import "./BuildVoyahDream.css";

import BuildDreamExterior from "../../components/BuildDream/BuildDreamExterior";
import BuildDreamInterior from "../../components/BuildDream/BuildDreamInterior";
import BuildDreamAE from "../../components/BuildDream/BuildDreamAE";
import BuildDreamOrder from "../../components/BuildDream/BuildDreamOrder";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const BuildVoyahDream = () => {
  // =============================================================
  // STATE FOR CONFIG + PRICES
  // =============================================================
  const [config, setConfig] = useState(null);
  const [colorPrices, setColorPrices] = useState({});
  const [equipmentPrices, setEquipmentPrices] = useState({});

  // =============================================================
  // SELECTED USER OPTIONS
  // =============================================================
  const [selectedExterior, setSelectedExterior] = useState(null);
  const [selectedInterior, setSelectedInterior] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState([]);

  // =============================================================
  // LOAD DREAM CONFIG
  // =============================================================
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/DreamBuildConfig`);
        setConfig(res.data);
      } catch (err) {
        console.error("Failed to load Dream config:", err);
      }
    };

    loadConfig();
  }, []);

  // =============================================================
  // LOAD PRICES (colors + equipment)
  // =============================================================
  useEffect(() => {
    const loadPrices = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/DreamPrices`);

        // Translate colors → { "Color": price }
        const colorsObj = {};
        res.data.colors.forEach((c) => {
          colorsObj[c.name] = c.price;
        });

        // Translate equipment → { id: price }
        const equipObj = {};
        res.data.equipment.forEach((e) => {
          equipObj[e.id] = e.price;
        });

        setColorPrices(colorsObj);
        setEquipmentPrices(equipObj);
      } catch (err) {
        console.error("Failed to load Dream prices:", err);
      }
    };

    loadPrices();
  }, []);

  // =============================================================
  // RENDER NOTHING UNTIL API LOADED
  // =============================================================
  if (!config || Object.keys(colorPrices).length === 0 || Object.keys(equipmentPrices).length === 0) {
    return null;
  }

  const BASE_PRICE = config.basePrice;
  const CURRENCY = config.currency;

  // =============================================================
  // TOTAL PRICE CALCULATION
  // =============================================================
  const calculateTotal = () => {
    let total = BASE_PRICE;

    // Exterior color price
    if (selectedExterior) {
      total += colorPrices[selectedExterior.name] || 0;
    }

    // Additional equipment
    selectedEquipment.forEach((id) => {
      total += equipmentPrices[id] || 0;
    });

    return total;
  };

  const finalPrice = calculateTotal();

  // =============================================================
  // EQUIPMENT SELECTION HANDLER
  // =============================================================
  const toggleEquipment = (id) => {
    setSelectedEquipment((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  // =============================================================
  // RENDER UI
  // =============================================================
  return (
    <div className="bvdnavedit">
      <Navbar />

      {/* EXTERIOR SELECTOR */}
      <BuildDreamExterior onSelect={(color) => setSelectedExterior(color)} />

      {/* INTERIOR SELECTOR */}
      <BuildDreamInterior onSelect={(interior) => setSelectedInterior(interior)} />



      {/* ORDER FORM */}
      <BuildDreamOrder
        finalPrice={finalPrice}
        currency={CURRENCY}
        selectedExterior={selectedExterior}
        selectedInterior={selectedInterior}
        selectedEquipment={selectedEquipment}
      />

      <Footer />
    </div>
  );
};

export default BuildVoyahDream;
